import React, { Suspense } from 'react';
import Loader from './Loader';

const RouteSuspense: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Suspense fallback={<Loader />}>{children}</Suspense>
);

export default RouteSuspense;
